<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                {{ documento.id ? "Editar Documento" : "Novo Documento" }}
              </h4>
            </div>
            <div class="card-body">
              <div class="row">

                <!-- Assunto -->
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Assunto <span class="text-danger">*</span></label>
                    <v-select
                      :options="assuntos"
                      label="nome"
                      :reduce="(a) => a.id"
                      v-model="documento.assunto_id"
                      placeholder="Selecione o assunto"
                      :disabled="assuntoFixo"
                    />
                  </div>
                </div>

                <!-- Título -->
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Título <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="documento.titulo"
                      id="tituloDocumento"
                      placeholder="Título do documento"
                    />
                  </div>
                </div>

                <!-- Upload de arquivo -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Arquivo</label>
                    <div class="upload-area rounded p-3">
                      <div v-if="arquivoAtual && !novoArquivo" class="mb-2 d-flex align-items-center">
                        <i :class="'fa ' + iconeAtual + ' fa-lg mr-2'"></i>
                        <span class="text-muted mr-2">Arquivo atual:</span>
                        <a :href="arquivoUrl" target="_blank" class="text-primary">
                          {{ documento.nome_original }}
                        </a>
                        <span class="badge badge-secondary ml-2">{{ (documento.extensao || '').toUpperCase() }}</span>
                      </div>

                      <input
                        type="file"
                        ref="arquivoInput"
                        class="d-none"
                        @change="onArquivoChange"
                        accept=".pdf,.xlsx,.xls,.docx,.doc,.pptx,.ppt,.jpg,.jpeg,.png,.gif,.bmp,.webp"
                      />

                      <div class="d-flex align-items-center flex-wrap" style="gap: 10px">
                        <button type="button" class="btn btn-primary btn-upload" @click="$refs.arquivoInput.click()">
                          <i class="fa fa-upload mr-1"></i> Escolher arquivo
                        </button>
                        <span v-if="novoArquivo" class="text-success font-weight-bold">
                          <i class="fa fa-check-circle mr-1"></i>{{ novoArquivo.name }}
                          <span class="text-muted font-weight-normal ml-1">({{ tamanhoArquivo }})</span>
                        </span>
                        <span v-else class="text-muted" style="font-size: 13px">Nenhum arquivo selecionado</span>
                      </div>

                      <small class="form-text text-muted mt-2">
                        Formatos permitidos: PDF, XLSX, DOCX, PPTX, JPG, PNG e outros. Tamanho máximo: 20MB.
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Descrição com CKEditor -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Descrição <span class="text-danger">*</span></label>
                    <ckeditor
                      :editor="editor"
                      v-model="documento.descricao"
                      :config="editorConfig"
                    ></ckeditor>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-right">
          <hr />
          <router-link
            :to="'/documentos' + (documento.assunto_id ? '?assunto_id=' + documento.assunto_id : '')"
            class="btn btn-back mr-1"
          >
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      documento: {
        assunto_id: null,
        titulo: "",
        descricao: "",
        arquivo: null,
        nome_original: null,
        extensao: null,
      },
      assuntos: [],
      assuntoFixo: false,
      novoArquivo: null,
      editor: ClassicEditor,
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedList",
          "bulletedList",
          "|",
          "outdent",
          "indent",
          "|",
          "blockQuote",
          "insertTable",
          "undo",
          "redo",
        ],
      },
    };
  },
  computed: {
    arquivoAtual() {
      return !!this.documento.arquivo;
    },
    arquivoUrl() {
      if (!this.documento.id) return null;
      return this.$store.state.api + "documentos/" + this.documento.id + "/visualizar";
    },
    iconeAtual() {
      const icones = {
        pdf: "fa-file-pdf-o text-danger",
        xlsx: "fa-file-excel-o text-success",
        xls: "fa-file-excel-o text-success",
        docx: "fa-file-word-o text-primary",
        doc: "fa-file-word-o text-primary",
        pptx: "fa-file-powerpoint-o text-warning",
        ppt: "fa-file-powerpoint-o text-warning",
        jpg: "fa-file-image-o text-info",
        jpeg: "fa-file-image-o text-info",
        png: "fa-file-image-o text-info",
        gif: "fa-file-image-o text-info",
      };
      const ext = (this.documento.extensao || "").toLowerCase();
      return icones[ext] || "fa-file-o";
    },
    tamanhoArquivo() {
      if (!this.novoArquivo) return "";
      const bytes = this.novoArquivo.size;
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },
  },
  methods: {
    onArquivoChange(event) {
      this.novoArquivo = event.target.files[0] || null;
    },

    makeFormData() {
      const fd = new FormData();

      fd.append("assunto_id", this.documento.assunto_id || "");
      fd.append("titulo", this.documento.titulo || "");
      fd.append("descricao", this.documento.descricao || "");

      if (this.novoArquivo) {
        fd.append("arquivo", this.novoArquivo);
      }

      if (this.documento.id) {
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save() {
      const self = this;

      if (!self.documento.assunto_id) {
        self.$message("Atenção", "Selecione um assunto.", "error");
        return;
      }
      if (!self.documento.titulo) {
        self.$message("Atenção", "Informe o título do documento.", "error");
        return;
      }
      if (!self.documento.descricao) {
        self.$message("Atenção", "Informe a descrição do documento.", "error");
        return;
      }

      self.$loading(true);

      let api = self.$store.state.api + "documentos";
      if (self.documento.id) {
        api += "/" + self.documento.id;
      }

      axios
        .post(api, self.makeFormData())
        .then(() => {
          self.$message("Sucesso", "Documento salvo com sucesso", "success");
          self.$loading(false);
          self.$router.push(
            "/documentos?assunto_id=" + self.documento.assunto_id
          );
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getDocumento(id) {
      const self = this;
      self.$loading(true);

      axios
        .get(self.$store.state.api + "documentos/" + id)
        .then((response) => {
          self.documento = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getAssuntos() {
      const self = this;
      axios
        .get(self.$store.state.api + "assuntos?paginated=false")
        .then((response) => {
          self.assuntos = response.data.data || response.data;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getAssuntos();

    const id = this.$route.params.id;
    if (id) {
      this.getDocumento(id);
    } else {
      const assunto_id = this.$route.query.assunto_id;
      if (assunto_id) {
        this.documento.assunto_id = parseInt(assunto_id);
        this.assuntoFixo = true;
      }
      this.$nextTick(() => {
        const el = document.getElementById("tituloDocumento");
        if (el) el.focus();
      });
    }
  },
  components: {
    vSelect,
  },
};
</script>

<style scoped>
.upload-area {
  background-color: #f8f9fa;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.upload-area:hover {
  transform: scale(1.002);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.32);
}

.btn-upload {
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 500;
}
</style>

<style>
/* Dark mode — área de upload */
.dark-layout .upload-area {
  background-color: #283046;
  border-color: #3b4253 !important;
}

/* Altura mínima do CKEditor */
.ck.ck-editor__main > .ck-editor__editable {
  min-height: 200px;
}

/* Dark mode — forçar texto preto dentro do CKEditor (fundo permanece branco) */
.dark-layout .ck.ck-editor__main > .ck-editor__editable {
  color: #333 !important;
}

/* Dark mode — v-select (normal e disabled) */
.dark-layout .vs--disabled .vs__dropdown-toggle,
.dark-layout .vs__dropdown-toggle {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
}
.dark-layout .vs__search,
.dark-layout .vs__search::placeholder,
.dark-layout .vs__selected,
.dark-layout .vs--disabled .vs__selected {
  color: #d0d2d6 !important;
}
.vs--disabled .vs__dropdown-toggle {
  background-color: transparent !important;
}
.vs--disabled .vs__search {
  background-color: transparent !important;
}
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__deselect,
.vs--disabled .vs__clear {
  display: none !important;
}
.dark-layout .vs__open-indicator {
  fill: #d0d2d6 !important;
}
.dark-layout .vs__dropdown-menu {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
}
.dark-layout .vs__dropdown-option {
  color: #d0d2d6 !important;
}
.dark-layout .vs__dropdown-option--highlight {
  background-color: #7367f0 !important;
  color: #fff !important;
}
</style>
